jQuery(function ($) {
	'use strict';

	var $lightBox = $('.js-lightbox');
	var $body = $('body');

	if (!$lightBox.length) {
		return;
	}

	$body.append(
		'<div class="lightbox-overlay"></div><div class="lightbox-img"></div>'
	);

	var $overlay = $('.lightbox-overlay');
	var $img = $('.lightbox-img');
	var $close = $('.lightbox-close');

	$overlay.on('click', function () {
		$(this).hide();
		$img.hide();
	});

	$lightBox.find('a').on('click', function () {
		$overlay.show();
		$img.show().html(
			'<img src="' + $(this).attr('href') + '" /><span class="lightbox-close">✖</span>'
		);
		return false;
	});

	$body.on('click', $close, function () {
		$img.hide();
		$overlay.hide();
	});

});
